import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseDeleteSharedFileMutationOptions {
	onSuccess?: () => void;
	onError?: () => void;
}

interface DeleteSharedFileMutationParams {
	id: string;
	deleteSourceFile: boolean;
	contactId: string;
}

export function useDeleteSharedFileMutation({ onSuccess, onError }: UseDeleteSharedFileMutationOptions = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async ({ id, deleteSourceFile }: DeleteSharedFileMutationParams) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `SharedFile/${encodeURIComponent(id)}`,
					queryParams: { deleteSourceFile },
				}),
				'DELETE'
			);
		},
		onSuccess: (_, { contactId }) => {
			queryClient.invalidateQueries({ queryKey: ['SharedFile/byContact', contactId] });
			onSuccess?.();
		},
		onError,
	});
}
